import styled from 'styled-components';

export const TimelineWrapper = styled.div`
  margin: 30px 0;
`;
